<template>
	<div class="ld-panel-title">
		<router-link to="/hosts" class="back-btn"><span></span>实例续费</router-link>
	</div>
	<div class="ld-panel-main">
		<el-table ref="tableRef" :data="tableData" highlight-current-row style="width: 100%" @current-change="handleCurrentChange">
			<el-table-column width="50">
				<span class="icon"></span>
			</el-table-column>
			<el-table-column prop="text" label="产品年限" />
			<el-table-column prop="time" label="续费后时间" />
			<el-table-column prop="market_price" label="市场价格" />
			<el-table-column prop="my_price" label="我的价格" />
		</el-table>
		<div class="price">当前余额：<el-text style="color: #ff6600;" size="large">{{balance}}元</el-text></div>
		<el-button type="primary" @click="submitForm">立即续费</el-button>
	</div>
</template>

<script setup>
	import { ref,reactive,inject,onMounted } from 'vue';
	import { useRouter } from 'vue-router';
	import { delaySpec,delayOrder } from '@/api/host';
	import { ElMessage, ElMessageBox } from 'element-plus';
	
	const domain = inject('domain');
	const router = useRouter();
	const Id = ref('');
	const balance = ref('');
	const month = ref();
	const tableData = ref('');
	const tableRef = ref(null);
	const currentRow = ref('');
	
	const gernaData = () => {
		const param = {'instance_id':Id.value}
		delaySpec(param).then((res) => {
			if (res.code == 200) {
				balance.value = res.data.balance;
				tableData.value = res.data.list;
				tableRef.value.setCurrentRow(res.data.list[0]);
				month.value = res.data.list[0].month;
			}
		});
	};
	const handleCurrentChange = (val) => {
		currentRow.value = val;
		month.value = val.month;
	}
	const submitForm = () => {
		const param = {'instance_id':Id.value,'month':month.value}
		delayOrder(param).then((res) => {
			if (res.code == 200) {
				if (res.data.id == '') {
					ElMessageBox.alert('下单失败', '温馨提示', {
						customClass: 'error-box',
						showConfirmButton: false,
						callback: action => {
						      
						}
					})
				} else{
					window.location.href = domain+"/user/orders/changestype.html?id="+res.data.id;
				}
			}
		});
	}
	
	onMounted(() => {
		if(router.currentRoute.value.query){
			Id.value = router.currentRoute.value.query.id;
		}
		gernaData()
	})
	
</script>

<style lang="scss" scoped>
	.icon{ display: block; width: 16px;height: 16px;background: url(../../assets/images/radio-normal.png) center no-repeat;}
	.current-row .icon{background: url(../../assets/images/radio-checked.png) center no-repeat;}
	.head{
		margin-bottom: 30px;
		overflow: hidden;
		p{margin-top:10px;font-size: 12px;color: #a0a2a3;}
	}
	.price{margin: 20px 0;overflow: hidden;}
	
</style>